/*
This file is a copy of node_modules/datatables.net-buttons-bs5/js/buttons.bootstrap5.js
but with additional classes added for Aurion styling. The factory function was also removed from the original file
because this will only be run in the browser.
*/

'use strict';

export default function addAurionDefaultButtonConfig(DataTable) {
    Object.assign(DataTable.Buttons.defaults.dom.button, {
        className: 'btn btn-secondary btn-sm',
        liner: { tag: 'span' },
    });

    Object.assign(DataTable.Buttons.defaults.dom, {
        container: {
            className: 'dt-buttons',
            tag: 'div',
        },
    });

    Object.assign(DataTable.Buttons.defaults.dom.collection.container, {
        tag: 'div',
        className: 'dropdown-menu dt-button-collection',
    });

    Object.assign(DataTable.Buttons.defaults.dom.collection, {
        closeButton: false,
        button: {
            tag: 'a',
            className: 'dt-button dropdown-item',
            active: 'active',
            disabled: 'disabled',
            spacer: {
                className: 'dropdown-divider',
                tag: 'hr',
            },
        },
    });
}
